import service from '../request'
const baseUrl = window.globalUrl.HOME_API;
//获取店铺商家资金信息
export const getShopAccount = () => {
  return service({
    url: `${baseUrl}/mall/shop/getShopAccount`,
    method: 'get'
  })
}

//获取体现记录列表
export const getWithdrawList = (params) => {
  return service({
    url: `${baseUrl}/mall/fund/withdrawList`,
    method: 'get',
    params: params
  })
}

//获取收支明细列表
export const getBalanceLogList = (params) => {
  return service({
    url: `${baseUrl}/mall/fund/balanceLogList`,
    method: 'get',
    params: params
  })
}

//申请提现
export const withdrawApply = (params) => {
  return service({
    url: `${baseUrl}/mall/fund/withdrawApply`,
    method: 'post',
    params: params
  })
}

//会计主管查看体现申请列表
export const getWithdrawApplyList = (params) => {
  return service({
    url: `${baseUrl}/mall/withdrawApply/list`,
    method: 'get',
    params: params
  })
}

//提现申请详情
export const getWithdrawApplyDetail = (params) => {
  return service({
    url: `${baseUrl}/mall/withdrawApply/detail`,
    method: 'get',
    params: params
  })
}

//提现申请确认完成
export const withdrawApplyConfirm = (params) => {
  return service({
    url: `${baseUrl}/mall/withdrawApply/confirm`,
    method: 'post',
    params: params
  })
}
